import React, { createContext, useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import config from "../../app/config";
import { useOktaAuth } from "@okta/okta-react";
const StringResourceContext = createContext("en");

const StringResourceProvider = ({ children }) => {
  const [cookies, setCookie] = useCookies(["nf_lang"]);
  const [dictionary, setDictionary] = useState({});
  const [locale, setLocale] = useState(cookies.nf_lang ?? "en");
  const [lang, setLang] = useState(cookies.nf_lang ?? "en");
  const { authState, oktaAuth } = useOktaAuth();
  const accessToken = oktaAuth.getAccessToken();
  
  const stringResourceQuery = `
        query stringResourcesData($locale: String) {
        stringResourcesCollection(locale: $locale, limit:1000)
        {
            items {
                sys {
                    id
                    locale
                }
                key
                value 
                }
            }
        }
   `;

  const handleSetLocale = (locale) => {
    let _lang = "en";

    if (locale.substring(0, 2) === "fr") {
      _lang = "fr";
    }

    setLocale(_lang);
    setLang(_lang);
    setCookie("nf_lang", _lang, { path: "/" });
  };

  const getStringResourceData = async () => {

    fetch(config.resourceServer.contentfulApimAgentGqlUrl, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
        query: stringResourceQuery,
        variables: { locale: locale === "fr" ? locale : "en-CA" },
        }),
    })
    .then((response) => response.json())
    .then(({ data }) => {
        let parsedDictionary = { ...dictionary };
        data.stringResourcesCollection?.items.forEach((item) => {
          const entryLang = item?.sys?.locale.substring(0, 2);

          if (!parsedDictionary[entryLang]) {
            parsedDictionary[entryLang] = {};
          }

          parsedDictionary[entryLang][item.key] = {
            parseAsMarkdown: item?.parseAsMarkdown,
            value: item?.value,
          };
        })
        setDictionary(parsedDictionary);
    })
        .catch((err) => {
        console.error(err);
    });
  };

  // fetch messages
  useEffect(() => {
    if ( authState && authState.isAuthenticated && !dictionary[locale]) {
      getStringResourceData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState, oktaAuth, locale, dictionary]);
  
  return (
    <StringResourceContext.Provider
      value={{
        locale: locale.substring(0, 2),
        lang,
        setLocale: handleSetLocale,
        dictionary,
      }}
    >
      {children}
    </StringResourceContext.Provider>
  );
};

export default StringResourceProvider;
export { StringResourceProvider, StringResourceContext };
